const seen = new Set();

function scheduleIdle(fn) {
  if (typeof window === 'undefined') return;
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(fn, { timeout: 1500 });
    return;
  }
  // Fallback: small delay to avoid blocking render.
  setTimeout(fn, 60);
}

/**
 * Prefetch image URLs into the browser cache (and SW runtime cache).
 * Uses in-memory "seen" guard so we don't spam requests.
 *
 * @param {string[]} urls
 * @param {object} [opts]
 * @param {number} [opts.max] - max URLs to prefetch
 */
export function prefetchImages(urls, opts = {}) {
  if (typeof window === 'undefined') return;
  const max = typeof opts.max === 'number' ? opts.max : 10;

  const list = (Array.isArray(urls) ? urls : [])
    .map((u) => String(u || '').trim())
    .filter(Boolean)
    .filter((u) => !seen.has(u))
    .slice(0, Math.max(0, max));

  if (!list.length) return;

  list.forEach((u) => seen.add(u));

  scheduleIdle(() => {
    for (const u of list) {
      try {
        const img = new Image();
        // Helps with hotlink-protected hosts in some cases (same as our <img> tags).
        try {
          img.referrerPolicy = 'no-referrer';
        } catch {
          // ignore if unsupported
        }
        img.decoding = 'async';
        img.loading = 'eager';
        img.src = u;
      } catch {
        // ignore
      }
    }
  });
}




